import { Box, Button, Typography, useTheme } from '@material-ui/core'
import { OpenInNewWindowIcon } from 'components/icons'
import { useEffect } from 'react'
import { track, useTracking } from 'lib/babylistHealthAnalytics'
import useStyles from './styles'
import { OrderInProgressCopy } from './OrderInProgressCopy'
import { OrderInIntervalCopy } from './OrderInIntervalCopy'
import { AwaitingPaidInvoiceCopy } from './AwaitingPaidInvoiceCopy'
import { UnknownErrorCopy } from './UnknownErrorCopy'
import { SubscriptionEndedCopy } from './SubscriptionEndedCopy'
import { InsuranceUnsupportedCopy } from './InsuranceUnsupportedCopy'
import { PUMP_PARTS_STORE_PAGE_URL, STORE_NAME } from '../../../constants'

export interface ReplacementPartsOrderBlockerProps {
  error: Exclude<
    APIResponse.DME.SubscriptionErrorType,
    // These errors are special cases handled by ReplacementPartsView
    'INSURANCE_VERIFICATION_FAILED'
  >
  subscription: APIResponse.DME.Subscription
}

const blockerComponents = {
  ORDER_IN_PROGRESS: OrderInProgressCopy,
  INSURANCE_UNSUPPORTED: InsuranceUnsupportedCopy,
  AWAITING_PAID_INVOICE: AwaitingPaidInvoiceCopy,
  ORDER_PLACED_WITHIN_INTERVAL: OrderInIntervalCopy,
  SUBSCRIPTION_ENDED: SubscriptionEndedCopy,
  UNKNOWN_ERROR: UnknownErrorCopy,
}

const ReplacementPartsOrderBlocker = ({
  error,
  subscription,
}: ReplacementPartsOrderBlockerProps) => {
  const theme = useTheme()
  const classes = useStyles()
  const tracker = useTracking()

  const BlockerComponent =
    blockerComponents[error] || blockerComponents.UNKNOWN_ERROR

  useEffect(() => {
    tracker.trackEvent({
      event: track.replacementPartsOrderBlockerViewed,
      blockerType: error,
      storeName: STORE_NAME,
    })
  }, [])

  return (
    <Box
      bgcolor={theme.palette.background.contrast}
      flexGrow={1}
      px={{ xs: 4, sm: 0 }}
      py={8}
    >
      <Box className={classes.container}>
        <BlockerComponent subscription={subscription} />

        <Typography
          className={classes.subtitle}
          color="primary"
          component="h1"
          variant="h4"
        >
          Need parts now?
        </Typography>
        <Typography className={classes.body} color="primary" variant="body2">
          We should have what you need on the Babylist Shop.
        </Typography>

        <Button
          classes={{ root: classes.linkButton }}
          color="secondary"
          endIcon={<OpenInNewWindowIcon />}
          href={PUMP_PARTS_STORE_PAGE_URL}
          size="large"
          variant="contained"
        >
          Shop for Pump Parts
        </Button>
      </Box>
    </Box>
  )
}

export default ReplacementPartsOrderBlocker
